<template lang="pug">
  .tile-calculator
    .header
      Icon(name="tiles")
      h4 {{__('Calculate tiles needed')}}
    .subtext
      i {{__('Note: Tiles are 1” thick and 2x2’ square feet each. These figures are used to find the tiles needed based on total square footage.')}}
    .calculate-flooring-by
      RogueInput(label="Total Square Feet" v-model="totalSquareFt" type="number" @keyup.enter="calculate" )
      .btn-container
        RogueButton(size="s" width="full" @click="calculate" :disabled="!totalSquareFt" :color="!totalSquareFt && 'flat-disabled'") {{__('Calculate')}}
    Message.error(status="error" v-if="error")
      | {{error}}
</template>
<script>
import { nextTick } from 'vue'
import { calculateTilesNeeded } from './utils'
import { createBuyRequest } from '@/js/helpers/buy-request'

export default {
  name  : 'TileCalculator',
  props : {
    rolls: {
      type    : Array,
      default : () => ([]),
    },
    buyRequest: {
      type     : Object,
      required : true,
    },
  },
  data() {
    return {
      totalSquareFt : null,
      error         : null,
    }
  },
  watch: {
    buyRequest: {
      deep: true,
      handler(newVal) {
        if (!newVal.qty) {
          nextTick(() => {
            this.totalSquareFt = null
          })
        }
      },
    },
  },
  methods: {
    optionBuyRequest(option) {
      const br = createBuyRequest(option, this.$rogue)
      br.qty = option.qty

      return br
    },
    calculate() {
      this.error = null
      if (this.totalSquareFt <= 0) {
        this.error = 'Please provide a positive value to calculate tiles needed'
      }
      const qty = calculateTilesNeeded(this.totalSquareFt, this.rolls)
      this.buyRequest.children[0].qty = qty
    },
  },
}
</script>
<style lang="scss" scoped>
.tile-calculator {
  margin: $size-m 0;
  .header {
    display: flex;
    h4 {
      margin-left: 6px;
    }
  }
  .subtext {
    margin: $size-s 0;
    font-size: $size-xs;
  }
  .calculate-flooring-by {
      display: flex;
      justify-content: space-between;
      align-items: center;
      > * {
        width: 48%;
      }
    .btn-container {
      margin-top: 5px;
      .btn-container {
        margin-top: 4px;
        :deep() {
          .flat-disabled {
            color: black;
          }
        }
      }
    }
  }
}
</style>
